<template>
	<div class="legend-view">
		<div class="item" v-for="(item, i) in _items" :key="i" :style="{ right: 100 + (i * 50) + 'px' }">
			<div class="orb" :style="{ backgroundColor: item.color }"></div>
			<div class="label">{{ item.label }}</div>
		</div>
		<div class="orb" @click="open = !open">
			<svgicon icon="help" />
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				open: false
			};
		},
		props: {
			items: {
				type: Array,
				default() {
					return [];
				}
			}
		},
		computed: {
			_items() {
				var r = [];

				if (this.open) r = this.items;

				return r;
			}
		},
		mounted() {
			
		}
	}
</script>

<style lang="scss" scoped>
	.legend-view {
		position: absolute;
		left: 0;
		top: 0;
		width: 100%;
		height: 100%;
		pointer-events: none;
		overflow: hidden;

		& > .item {
			position: absolute;
			bottom: 32px;

			& > .orb {
				width: 16px;
				height: 16px;
				border-radius: 50%;
				border: 3px solid white;
				box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
			}

			& > .label {
				position: absolute;
				left: -10px;
				top: -85px;
				transform: rotate(-45deg);
				white-space: nowrap;
				width: 200px;
			}
		}

		& > .orb {
			position: absolute;
			right: 20px;
			bottom: 20px;
			width: 40px;
			height: 40px;
			border-radius: 50%;
			background-color: #f7223f;
			border: 3px solid white;
			cursor: pointer;
			padding: 7px;
			pointer-events: all;
			box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);

			& > svg {
				position: absolute;
				fill: white;
				width: 20px;
				height: 20px;
			}
		}
	}
</style>